import type {
  FirstInstallAttributionSource,
  FirstInstallOnboardingProduct,
} from "@redotech/redo-model/onboarding";
import { readIntentMarker } from "./intent-marker";

export interface IntentAutoOnboardingAnswers {
  attributionSource: FirstInstallAttributionSource;
  selectedProduct: FirstInstallOnboardingProduct;
}

/**
 * For TOFU intent-ad merchants we already know why they came (social
 * ad campaign) and what they want (intent rescue, which lives under
 * the checkout-optimization product family). The onboarding modal can
 * skip the attribution + product steps and pre-fill the answers
 * server-side via completeFirstInstallOnboarding so the onboarding
 * doc is still consistent for analytics — the merchant goes straight
 * from accepting terms to the intent-setup wizard.
 *
 * Returns null for organic installs — they should see the normal
 * three-step modal. This is a read, not a consume: the marker is
 * cleared later by consumeIntentAdOverride in routeToDestination so
 * the one-shot semantics stay centralized in one place.
 */
export function readIntentAutoOnboardingAnswers(): IntentAutoOnboardingAnswers | null {
  if (!readIntentMarker()) {
    return null;
  }
  return {
    attributionSource: "social",
    selectedProduct: "checkout-optimization",
  };
}
